import React, { useEffect, useState } from "react";
import axios from "axios"; 

const Letters = () => {
  const [Associations, setAssociations] = useState([]);

  useEffect(() => {
    axios
      .get("https://www.isolsgroup.com/new/api/ApiLetterAssociation", {
        headers: {
          "X-API-KEY": "ISOLS", // 🔐 Replace with your actual key if required
        },
        params: { // sends ?category_id=5
          homepage: 1, // ✅ filter only homepage = 1
        }
      })
      .then((response) => {
        if (response.data && Array.isArray(response.data.data)) {
          // ✅ Limit to only first 4 records
          const homepageLetters = response.data.data
            .filter((item) => item.homepage === "1" || item.homepage === 1)
            .slice(0, 4);
          setAssociations(homepageLetters);
        } else {
          console.warn("Unexpected API response:", response.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching Letter data:", error);
      });
  }, []);



return (
    <div
        className="b-home-team relative"
        style={{ background: "#f9f9fa", padding: "40px 0" }}
      >
        <div className="container">
          <div className="row">
            <div className="b-team">
              <div className="col-xs-12 col-sm-12">
                <div
                  className="b-member-info"
                  style={{
                    float: "left",
                    listStyle: "none",
                    position: "relative",
                    marginBottom: "20px",
                  }}
                >
                  <div className="col-xs-12 col-sm-3">
                    <div className="b-mod-heading">
                      <p className="first-heading font-secondary member-prof">
                        Letter of{" "}
                      </p>
                      <h4
                        className="heading-line line-right customColor customPseudoElBg member-name"
                        style={{ fontSize: "38px" }}
                      >
                        <strong>Association</strong>
                      </h4>
                    </div>
                  </div>
                  <div className="col-xs-12 col-sm-9">
                    <div className="b-member-caption">
                      <h6 className="contact-info-title customPseudoElBg font-secondary">
                        Letter of Association, Appreciation & Institutional
                        Partnership
                      </h6>
                      <p>
                        We are proud to be the Education Partner with IIT Bombay
                        and to have received a Letter of Appreciation from PNB
                        Bank for Cyber Crime Awareness Training. We also
                        received an Exclusive Invitation from Bharat Mandapam
                        for prestigious national events.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Partner Letters */}
              <div className="col-xs-12 col-sm-12">
                <div className="row">
                  <div className="bx-wrapper letter">
                    <div className="bx-viewport">
                      <div
                        className="member-list-item clearfix"
                        style={{
                          float: "left",
                          listStyle: "none",
                          position: "relative",
                        }}
                      >
                      {/* Partner 1 */}
                      {Associations.length > 0 ? (
                        Associations.map((association, index) => (
                          <div className="col-xs-12 col-sm-3 text-center" key={index}>
                            <div className="member-img">
                              <img
                                src={`https://www.isolsgroup.com/new/uploaded-images/association/${association.image}`}
                                className="img-responsive"
                                alt={association.name}
                              />
                            </div>
                            <div className="awrds">
                              <h3>{association.name}</h3>
                            </div>
                          </div>
                        ))
                        ) : (
                        <p className="text-center mt-4">No Data available.</p>
                        )}


                      </div>
                    </div>
                    <div className="bx-controls"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
);
};

export default Letters;
